import { Component, OnInit, Inject} from '@angular/core';
import { SiteMode } from '@classes/site-mode';
import { SiteModeService } from 'app/core/services/site-mode.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UiService } from 'app/core/services/ui.service';

@Component({
  selector: 'app-site-mode-detail',
  templateUrl: './site-mode-detail.component.html',
  styleUrls: ['./site-mode-detail.component.scss']
})
export class SiteModeDetailComponent implements OnInit {

  siteModeForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SiteModeDetailComponent>,
    private siteModeService: SiteModeService,
    private uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data: SiteMode
  ) { }

  ngOnInit() {
    this.initFormBuilder();
  }
  private initFormBuilder() {
    const fb = this.formBuilder;
    const siteModeForm = this.siteModeForm = fb.group({
      id: fb.control(this.data?.id),
      name: fb.control(this.data?.name, [Validators.required, Validators.maxLength(50)]),
    });
  }
  onSubmit() {
    const siteMode = new SiteMode(
      this.siteModeForm.value
    )
    this.uiService.addRouteLoading();
    this.siteModeService.createOrUpdateSiteMode(siteMode).subscribe(data => {
      this.dialogRef.close(true);
      this.uiService.displayMessageToast('site-mode.success-edit');
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
